
import {
  Usuario
} from '../index';


export class UsuarioPerfil {
  "Codigo";
  "Nome";
  "Descricao";
  "Ativo";
  "UsuarioAlteracao";
  "DataAlteracao";
  Usuarios;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UsuarioPerfil`.
   */
  static getModelName() {
    return "UsuarioPerfil";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UsuarioPerfil for dynamic purposes.
  **/
  static factory(data) {
    return new UsuarioPerfil(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'UsuarioPerfil',
      plural: 'UsuarioPerfils',
      path: 'UsuarioPerfils',
      properties: {
        "Codigo": {
          name: 'Codigo',
          type: 'number'
        },
        "Nome": {
          name: 'Nome',
          type: 'string'
        },
        "Descricao": {
          name: 'Descricao',
          type: 'string'
        },
        "Ativo": {
          name: 'Ativo',
          type: 'boolean',
          default: true
        },
        "UsuarioAlteracao": {
          name: 'UsuarioAlteracao',
          type: 'string'
        },
        "DataAlteracao": {
          name: 'DataAlteracao',
          type: 'Date'
        },
      },
      relations: {
        Usuarios: {
          name: 'Usuarios',
          type: 'Usuario[]',
          model: 'Usuario'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/UsuarioPerfil.js